import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import { Col } from "react-bootstrap";
import {
  emptyDonut,
  getTotalValue,
  tooltipContentStyle,
  tooltipCursorStyle,
} from "utils/dashboardUtils";

const DonutDistribution = ({ title, data, cols = { lg: 4 } }) => {
  const { t } = useTranslation();

  const totalValue = getTotalValue(data);
  const chartData = totalValue === 0 ? emptyDonut : data;


  return (
    <Col {...cols}>
      <div className="donut_card dashboard_common_card">
        <h3 className="fs_20">{t(title)}</h3>

        {/* Donut */}
        <div className="donut_chart py-2">
          <ResponsiveContainer width={175} height={175}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                innerRadius={60}
                outerRadius={80}
                startAngle={90}
                endAngle={-270}
                stroke="none"
              >
                {chartData.map((item, index) => (
                  <Cell key={index} fill={item.color} />
                ))}
              </Pie>
              {totalValue > 0 && (
                <Tooltip
                  cursor={tooltipCursorStyle}
                  formatter={(value, name) => [`${value}%`, t(name)]}
                  contentStyle={tooltipContentStyle}
                />
              )}
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Legend */}
        <div className="donut_legend">
          {data.map((item) => (
            <div key={item.name} className="donut_legend_item">
              <div className="heading_label">
                <span className="dot" style={{ background: item.color }} />
                <strong>{item.value}%</strong>
              </div>
              <p>{t(item.name)}</p>
            </div>
          ))}
        </div>
      </div>
    </Col>
  );
};

export default DonutDistribution;
